import { combineReducers } from 'redux';
import docummentsData, {
  templatesData,
  liteViewProjectsData,
  sunburstData,
  crmProjectsData,
  ProjectsByCompanyData,
} from './documents-data';
import dashboardData, {
  legalTasksData,
  insightsData,
  taskViewData,
  dashboardLiteData,
  contentsData,
  allContentsData,
  singleContentData,
} from './dashboard-data';
import saveTasksData, {
  assigneesData,
  taskStepData,
  createdStepData,
  updatedStepData,
  singleTaskStepData,
  populatedFromType,
  promptContextData,
} from './task-info';
import updatedTasksData from './update-task-info';
import projectData, {
  tagsData,
  formValuesData,
  boardCustomAttributesData,
  statusesData,
  anotherStatusesData,
  singleStatusData,
} from './create-project';
import loginData, { vendorData, notificationsData, maapLinkData } from './login';
import documentsType, { documentsTypeData } from './documents-type';
import singleProjectData, {
  singleProjectWithHeader,
  taskPreviews,
  meddpiccData,
} from './single-project';
import { commentsData, postedComments, updatedComments, boardCommentsData } from './comments';
import {
  showLoader,
  dialog,
  companies,
  pathname,
  keepThis,
  messageData,
  quarterData,
  monthlyData,
  promptData,
  isUserSelected,
  restart,
} from './loader';
import {
  companiesData,
  createdCompany,
  companyFavIcon,
  companyData,
  companyAccessData,
  companyHierarchyData,
} from './companies';
import snackbar from './snackbar';
import {
  userData,
  singleUserData,
  updatedUserData,
  updatedLiteUserData,
  allUsersData,
  allLightUsersData,
  createdUserData,
  tenantData,
  tenantAttributesData,
  singleTenantAttributesData,
  createdTenantAttributesData,
  updatedTenantAttributesData,
  customAttributesData,
  copyMaapLinkData,
} from './user-info';
import {
  uploadedDocs,
  uploadDocument,
  updatedDocument,
  singleCardDocs,
  clausesData,
  singleClausesData,
  clauseLibraryData,
} from './document-upload';
import { storedData } from './store-data';
import { completedData } from './completed-value';
import { clonedBoardData, clonedDocumentData } from './clone-data';
import { tabValues } from './tab-values';
import singleCardData, { filteredCardsData } from './single-task';
import eventsData from './events';
import { nudgeData, activationEmailData, resetPasswordData } from './nudge-mail';
import { reloadedData } from './reload-data';
import {
  crmDealsData,
  crmCompanyData,
  crmContactData,
  crmConnectedData,
  crmStatusData,
  crmSyncData,
  singleCrmData,
  crmDealsDataBySearch,
} from './crm-data';
import { createdtenantData, superUserData, uuidData, subDomainProp } from './create-tenant';
import feedbackData, { faqsData, singleFaqData } from './feedback';
import {
  userAccessGroups,
  postedAccessGroups,
  permissionsData,
  accessPermissionsData,
  groupPermissionsData,
  removedAccessGroup,
  singleAccessGroupData,
  forecastData,
  userHierarchyData,
  orgHierarchyData,
  groupViewData,
} from './user-access';
import { secretUrlData, postOtpData, token2Data, loginWithOtpData, refreshTokenData } from './mfa';
import {
  slackHistoryData,
  slackInviteData,
  postedSlackMessage,
  newSlackChannelData,
  workspaceInviteData,
  boardMembersData,
} from './slack-stuffs';
import { dealPoliceData, createdDealPoliceData, updatedPoliceData } from './deal-police';
import { allTenantsData } from './admin/tenant-list';

const appReducers = combineReducers({
  docummentsData,
  templatesData,
  sunburstData,
  crmProjectsData,
  liteViewProjectsData,
  ProjectsByCompanyData,
  dashboardData,
  legalTasksData,
  insightsData,
  taskViewData,
  dashboardLiteData,
  saveTasksData,
  updatedTasksData,
  projectData,
  contentsData,
  tagsData,
  loginData,
  vendorData,
  documentsType,
  documentsTypeData,
  singleProjectData,
  singleProjectWithHeader,
  commentsData,
  singleContentData,
  boardCommentsData,
  postedComments,
  updatedComments,
  showLoader,
  dialog,
  companies,
  companiesData,
  createdCompany,
  companyFavIcon,
  companyData,
  companyHierarchyData,
  snackbar,
  userData,
  singleUserData,
  updatedUserData,
  updatedLiteUserData,
  createdUserData,
  allUsersData,
  allLightUsersData,
  storedData,
  uploadDocument,
  updatedDocument,
  singleCardDocs,
  uploadedDocs,
  clausesData,
  singleClausesData,
  clauseLibraryData,
  completedData,
  clonedBoardData,
  clonedDocumentData,
  tabValues,
  singleCardData,
  filteredCardsData,
  eventsData,
  assigneesData,
  nudgeData,
  populatedFromType,
  promptContextData,
  tenantData,
  singleTenantAttributesData,
  createdTenantAttributesData,
  updatedTenantAttributesData,
  activationEmailData,
  resetPasswordData,
  reloadedData,
  messageData,
  quarterData,
  crmDealsData,
  crmCompanyData,
  crmContactData,
  crmConnectedData,
  crmStatusData,
  crmSyncData,
  crmDealsDataBySearch,
  createdtenantData,
  superUserData,
  uuidData,
  tenantAttributesData,
  subDomainProp,
  feedbackData,
  faqsData,
  singleFaqData,
  pathname,
  keepThis,
  userAccessGroups,
  forecastData,
  userHierarchyData,
  orgHierarchyData,
  postedAccessGroups,
  permissionsData,
  accessPermissionsData,
  groupPermissionsData,
  removedAccessGroup,
  singleAccessGroupData,
  taskPreviews,
  secretUrlData,
  postOtpData,
  token2Data,
  loginWithOtpData,
  slackHistoryData,
  slackInviteData,
  postedSlackMessage,
  workspaceInviteData,
  newSlackChannelData,
  boardMembersData,
  dealPoliceData,
  createdDealPoliceData,
  updatedPoliceData,
  allTenantsData,
  taskStepData,
  createdStepData,
  updatedStepData,
  singleTaskStepData,
  notificationsData,
  monthlyData,
  groupViewData,
  companyAccessData,
  formValuesData,
  customAttributesData,
  boardCustomAttributesData,
  promptData,
  meddpiccData,
  maapLinkData,
  singleCrmData,
  isUserSelected,
  statusesData,
  anotherStatusesData,
  singleStatusData,
  allContentsData,
  refreshTokenData,
  restart,
  copyMaapLinkData,
});

export default appReducers;
